module.exports = __webpack_public_path__ + "img/search-marker.f2e427ab.svg";